import { BrokerCommunication } from "@dune/types";
import { formatSimpleDate, formatEntityReference } from "@dune/utils";
import { ColumnDef } from "@tanstack/react-table";

export const communicationColumns: ColumnDef<BrokerCommunication>[] = [
	{
		id: "entityReference",
		header: "Référence",
		cell: ({ row }) => {
			const communication = row.original;
			if (
				!communication.relatedEntities ||
				communication.relatedEntities.length === 0
			) {
				return <div className="text-gray-500">-</div>;
			}

			const firstEntity = communication.relatedEntities[0];

			if (
				firstEntity.entityType === "PROPOSITION" &&
				firstEntity.entityReference === firstEntity.entityId
			) {
				return <div className="text-gray-500">-</div>;
			}

			const reference = formatEntityReference(
				firstEntity.entityType,
				firstEntity.entityReference,
			);

			return <div className="font-medium text-gray-900">{reference}</div>;
		},
		size: 150,
	},
	{
		accessorKey: "subject",
		header: "Sujet",
		cell: ({ row }) => {
			const communication = row.original;
			return (
				<div className="flex items-center gap-2">
					<span className="font-medium">{communication.subject}</span>
				</div>
			);
		},
		enableSorting: true,
		sortingFn: (rowA, rowB) => {
			const subjectA = rowA.original.subject;
			const subjectB = rowB.original.subject;
			return subjectA.localeCompare(subjectB);
		},
	},
	{
		accessorKey: "from",
		header: "De",
		cell: ({ row }) => {
			const from = row.original.from;
			return (
				<div className="flex items-center gap-2">
					<span>{from}</span>
				</div>
			);
		},
		enableSorting: true,
		sortingFn: (rowA, rowB) => {
			const nameA = rowA.original.from;
			const nameB = rowB.original.from;
			return nameA.localeCompare(nameB);
		},
	},
	{
		accessorKey: "to",
		header: "À",
		cell: ({ row }) => {
			const to = row.original.to;
			return (
				<div className="flex items-center gap-2">
					<span>{to.join(", ")}</span>
				</div>
			);
		},
		enableSorting: true,
		sortingFn: (rowA, rowB) => {
			const nameA = rowA.original.to.join(", ");
			const nameB = rowB.original.to.join(", ");
			return nameA.localeCompare(nameB);
		},
	},
	{
		accessorKey: "date",
		header: "Date",
		cell: ({ row }) => {
			return <span>{formatSimpleDate(row.original.date)}</span>;
		},
		enableSorting: true,
		sortingFn: (rowA, rowB) => {
			const dateA = new Date(rowA.original.date);
			const dateB = new Date(rowB.original.date);
			return dateA.getTime() - dateB.getTime();
		},
	},
];
